import React from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { useTenant } from "@/lib/tenant";
import { PageHeader, Panel, SevBadge, Empty } from "@/components/Bits";

export default function Vulnerabilities() {
  const { tenantId } = useTenant();
  const { data = [] } = useQuery({
    queryKey: ["vulns", tenantId],
    queryFn: () => api.get(`/vulnerabilities/${tenantId}`).then((r) => r.data),
    enabled: !!tenantId,
  });

  if (!tenantId) return <Empty msg="Select an MSP tenant" />;

  return (
    <>
      <PageHeader title="Vulnerable Apps" kicker={`${data.length} CVEs detected across fleet`} />
      <div className="p-6">
        <Panel>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="text-left font-mono text-[10px] uppercase tracking-widest text-zinc-500 border-b hairline">
                  <th className="px-4 py-3">Host</th>
                  <th className="px-3 py-3">Software</th>
                  <th className="px-3 py-3">Version</th>
                  <th className="px-3 py-3">CVE</th>
                  <th className="px-3 py-3">CVSS</th>
                  <th className="px-3 py-3">Patch</th>
                  <th className="px-3 py-3">Severity</th>
                </tr>
              </thead>
              <tbody>
                {data.map((v) => (
                  <tr key={v.id} className="border-b hairline hover:bg-white/[0.03]">
                    <td className="px-4 py-2.5 font-mono text-xs">{v.hostname}</td>
                    <td className="px-3 py-2.5">{v.software}</td>
                    <td className="px-3 py-2.5 font-mono text-xs text-zinc-400">{v.version}</td>
                    <td className="px-3 py-2.5 font-mono text-xs text-cyan-300">{v.cve}</td>
                    <td className="px-3 py-2.5 font-mono text-xs">{v.cvss}</td>
                    <td className="px-3 py-2.5">
                      <span className={`font-mono text-[10px] px-1.5 py-0.5 border ${v.patch_available ? "border-emerald-800 text-emerald-400" : "border-zinc-800 text-zinc-500"}`}>
                        {v.patch_available ? "AVAILABLE" : "N/A"}
                      </span>
                    </td>
                    <td className="px-3 py-2.5"><SevBadge sev={v.severity} /></td>
                  </tr>
                ))}
                {data.length === 0 && <tr><td colSpan={7}><Empty /></td></tr>}
              </tbody>
            </table>
          </div>
        </Panel>
      </div>
    </>
  );
}
